import { __assign } from "tslib";
export function isDropdownGroup(object) {
    return ('items' in object && Array.isArray(object.items) && object.items.length);
}
export function isNullableDropdownGroup(object) {
    return 'items' in object && Array.isArray(object.items);
}
export function isSelectableDropdownOption(object) {
    return 'value' in object;
}
export function convertNullableGroupToDropdownGroup(group) {
    var items = group.items.filter(function (item) { return !!item; });
    return items.length > 0 ? __assign(__assign({}, group), { items: items }) : undefined;
}
export function filterNullableDropdownItems(items) {
    return items
        .map(function (item) {
        return item &&
            (isNullableDropdownGroup(item)
                ? convertNullableGroupToDropdownGroup(item)
                : item);
    })
        .filter(function (item) { return !!item; });
}
export function findSelectedItem(items, lookInGroups) {
    if (lookInGroups === void 0) { lookInGroups = true; }
    var selectedItem;
    for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
        var item = items_1[_i];
        if (isDropdownGroup(item)) {
            if (lookInGroups) {
                selectedItem = findSelectedItem(item.items, false);
            }
        }
        else if (item.selected) {
            selectedItem = item;
        }
        if (selectedItem) {
            break;
        }
    }
    return selectedItem;
}
export function updateSelectionByValue(value, items, lookInGroups) {
    if (lookInGroups === void 0) { lookInGroups = true; }
    if (!value) {
        return items;
    }
    var updatedItems = [];
    for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
        var item = items_2[_i];
        if (isDropdownGroup(item)) {
            updatedItems.push({
                items: updateSelectionByValue(value, item.items, false),
            });
        }
        else {
            if (item && isSelectableDropdownOption(item)) {
                item.selected = item.value === value;
            }
            updatedItems.push(item);
        }
    }
    return updatedItems;
}
export function findItemByValue(value, items, lookInGroups) {
    if (lookInGroups === void 0) { lookInGroups = true; }
    if (value === undefined) {
        return undefined;
    }
    var matchingItem;
    for (var _i = 0, items_3 = items; _i < items_3.length; _i++) {
        var item = items_3[_i];
        if (isDropdownGroup(item)) {
            if (lookInGroups) {
                matchingItem = findItemByValue(value, item.items, false);
            }
        }
        else if (getItemValue(item) === value) {
            matchingItem = item;
        }
        if (matchingItem) {
            break;
        }
    }
    return matchingItem;
}
export function getItemValue(item) {
    return item.value !== undefined ? item.value : item.link;
}
export function getSelectedItemByValue(value, items) {
    if (value !== undefined) {
        return getFlatItemList(items).find(function (item) { return getItemValue(item) === value; });
    }
    return undefined;
}
export function hasSubmenus(items) {
    return getFlatItemList(filterNullableDropdownItems(items)).some(function (item) { return !!item.submenu; });
}
function getFlatItemList(items) {
    var flatItems = [];
    items.forEach(function (item) {
        if (isDropdownGroup(item)) {
            flatItems = flatItems.concat(item.items);
        }
        else {
            flatItems = flatItems.concat([item]);
        }
    });
    return flatItems;
}
//# sourceMappingURL=helpers.js.map